import {
    AiOutlineCreditCard,
    AiOutlineMail
} from "react-icons/ai";
import {FaAws} from "react-icons/fa";
import {RecordIcon as RegistrarIcon} from "../registrars/images/RecordIcon";
import {RecordIcon as DomainNameIcon} from "../domain-names/images/RecordIcon";
import {RecordIcon as TopLevelDomainIcon} from "../top-level-domains/images/RecordIcon";

// The Getting Started cards.
//
// Lifted out of IndexPage.tsx so they can be asserted against the route table
// (FNP-1389, sectionLinks.test.ts) without the page component coming along —
// react-refresh warns when one file exports both a component and shared data.
//
// ⚠️ A card whose `path` matches no route in src/config/routes.tsx sends the
// reader to the error boundary. `visible: false` does not make that safe, it
// only postpones it: FNP-1389 shipped a card pointing at `/route53-domains`,
// a route that has never existed, and nobody noticed because the card was
// hidden. Check every path here against routes.tsx, hidden ones included.
export const sections = [{
    title: 'Add Registrars',
    text: 'Add unlimited number of registrars to your portfolio',
    icon: <RegistrarIcon size={'3em'}/>,
    link: {
        title: 'Registrars',
        path: '/registrars/add'
    },
    visible: true
}, {
    title: 'View Top Level Domains',
    text: 'Browse top level domains for your portfolio',
    icon: <TopLevelDomainIcon size={'3em'}/>,
    link: {
        title: 'Top Level Domains',
        path: '/top-level-domains'
    },
    visible: true
}, {
    title: 'Add Domain Names',
    text: 'Add domain name(s) to your portfolio.',
    icon: <DomainNameIcon size={'3em'}/>,
    link: {
        title: 'Domain Names',
        path: '/domain-names/add'
    },
    visible: true
}, {
    title: 'Enable Integration with AWS',
    text: 'Enable integration with AWS',
    icon: <FaAws size={'3em'}/>,
    link: {
        title: 'AWS',
        path: '/provider-connections'
    },
    visible: false
}, {
    title: 'Invite others to use the application',
    text: 'Send invitations to other users to use the application.',
    icon: <AiOutlineMail size={'3em'}/>,
    link: {
        title: 'Invitations',
        path: '/settings/tenant-members'
    },
    visible: false
}, {
    title: 'Update Your Billing Info',
    text: 'Update your billing info. ',
    icon: <AiOutlineCreditCard size={'3em'}/>,
    link: {
        title: 'Billing',
        path: '/settings/payment-and-billing'
    },
    visible: false
}]
